module.exports = {
    categoryData : () => {
        return [
            {
                "Nombre":"AUTOMÓVILES",
                "Imagen":require("./../UI/canvas/sidebar/categorias/Automoviles.webp"),
            },
            {
                "Nombre":"CAMIONETAS",
                "Imagen":require("./../UI/canvas/sidebar/carros/Bronco Sport BB.webp"),
            },
            {
                "Nombre":"PICK-UPS",
                "Imagen":require("./../UI/canvas/sidebar/categorias/Pick-up.webp"),
            },
            {
                "Nombre":"PERFORMANCE",
                "Imagen":require("./../UI/canvas/sidebar/categorias/Performance.webp"),
            },
            {
                "Nombre":"HÍBRIDOS",
                "Imagen":require("./../UI/canvas/sidebar/categorias/Hibridos.webp"),
            }
        ]
    }
}